import {combineReducers} from 'redux';

import population from './population';

export default combineReducers({
  population
});
